<template>
  <div class="dark-mode-toggle flex cursor-pointer" @click="toggleDarkMode()">
    <div
      class="focus transition-all duration-300"
      :class="{
        '-ml-[2px]': isDarkModeEnabled,
        'ml-[26px]': !isDarkModeEnabled,
      }"
    >
      <img v-if="isDarkModeEnabled" src="/img/moon.svg" />
      <img v-if="!isDarkModeEnabled" src="/img/sun.svg" />
    </div>
    <div class="img-holder">
      <img src="/img/moon.svg" />
    </div>
    <div class="img-holder">
      <img src="/img/sun.svg" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isDarkModeEnabled: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    toggleDarkMode() {
      this.$emit("toggle-dark-mode");
    },
  },
};
</script>

<style lang="scss">
.dark-mode-toggle {
  height: 32px;
  border-radius: 16px;
  border: 1px solid rgba(32, 69, 80, 0.3);
  z-index: 50;
  display: flex;
  align-items: center;
  background: transparent;

  .focus {
    position: absolute;
    z-index: 1;
    margin-top: -1px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border-radius: 16px;
    border: 1px solid transparent;
    background-image: linear-gradient(white, white),
      linear-gradient(to right, #e8f5b7, #204550);
    background-origin: border-box;
    background-clip: padding-box, border-box;
  }

  .img-holder {
    z-index: 0;
    position: relative;
    height: 32px;
    width: 32px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:last-of-type {
      margin-left: -8px;
    }

    img {
      position: relative;
      margin-top: -3px;
      height: 15px;
      width: 15px;
    }
  }
}

.dark .dark-mode-toggle {
  border: 1px solid rgba(232, 245, 183, 0.3);

  .focus {
    background-image: linear-gradient(#204550, #204550),
      linear-gradient(to right, #e8f5b7, #204550);
  }

  img {
    filter: invert(100%);
  }
}
</style>
